<ion-header [hidden]="layoutType === 'sidebar'">
  <div
    class="button-container"
    [ngClass]="{ 'linear-gradient-subtle-animated': isProcessingBulkUpdate }"
  >
    <div class="flexed-align-center flex-space-between">
      <div
        class="flex-space-between"
        style="width: 100%"
        [hidden]="selectedConversations?.length || isProcessingBulkUpdate"
      >
        <div style="display: flex; align-items: center">
          <ion-searchbar
            mode="ios"
            class="search-bar hidden-sm"
            placeholder="Search conversations..."
            showCancelButton="never"
            [(ngModel)]="searchText"
            (ionChange)="onSearch()"
          ></ion-searchbar>
          <div
            *ngIf="selectedTab?.key === INBOX_TYPES.ESCALATIONS"
            class="flexed-align-center"
          >
            <div class="pill-tab-container">
              <div
                class="round-pill-tab round-pill-tab-left"
                [ngClass]="{
                  'round-pill-tab-active': escalationsStatusView === 'open'
                }"
                (click)="escalationsStatusView = 'open'; loadConversations()"
              >
                Open
              </div>
              <div
                class="round-pill-tab"
                [ngClass]="{
                  'round-pill-tab-active': escalationsStatusView === 'resolved'
                }"
                (click)="
                  escalationsStatusView = 'resolved'; loadConversations()
                "
              >
                Resolved
              </div>
              <div
                class="round-pill-tab round-pill-tab-right"
                [ngClass]="{
                  'round-pill-tab-active': escalationsStatusView === 'all'
                }"
                (click)="escalationsStatusView = 'all'; loadConversations()"
              >
                All
              </div>
            </div>
            <ion-button
              fill="clear"
              color="dark"
              (click)="toggleEscalationsFilter()"
              class="btn-small"
            >
              <ion-icon
                [name]="
                  isFilteringEscalationsByMe
                    ? 'checkmark-circle'
                    : 'ellipse-outline'
                "
                class="margin-right-5"
              ></ion-icon>
              Assigned to me
            </ion-button>
          </div>
          <div
            [hidden]="
              selectedTab?.key === INBOX_TYPES.CLOSED ||
              selectedTab?.key === INBOX_TYPES.INTAKE ||
              selectedTab?.key === INBOX_TYPES.ESCALATIONS ||
              layoutType !== 'table' ||
              savedFilterId
            "
            style="margin-right: 10px; margin-left: 6px; flex-shrink: 0"
            class="pill-tab-container"
          >
            <div
              class="round-pill-tab round-pill-tab-left"
              [ngClass]="{
                'round-pill-tab-active': statusIndex === 0
              }"
              (click)="selectStatus(0)"
            >
              Open
            </div>
            <div
              class="round-pill-tab"
              [ngClass]="{
                'round-pill-tab-active': statusIndex === 1
              }"
              (click)="selectStatus(1)"
            >
              On Hold
            </div>
            <div
              class="round-pill-tab"
              [ngClass]="{
                'round-pill-tab-active': statusIndex === 2
              }"
              (click)="selectStatus(2)"
            >
              Closed
            </div>
            <div
              class="round-pill-tab round-pill-tab-right"
              [ngClass]="{
                'round-pill-tab-active': statusIndex === 3
              }"
              (click)="selectStatus(3)"
            >
              All
            </div>
          </div>
          <app-filter-button
            [options]="filterOptions"
            [selected]="filters"
            (didChange)="filtersDidChange($event)"
            savedFilterView="inbox"
            [savedFilterId]="savedFilterId"
            [saveHandler]="onSaveFilter"
            [allowNotEqualsOperator]="true"
            [projectId]="authService.selectedProject?.id ?? undefined"
            [hidden]="selectedTab?.key === INBOX_TYPES.ESCALATIONS"
          ></app-filter-button>
        </div>
        <div class="flexed-align-center">
          <ion-button
            fill="clear"
            color="dark"
            (click)="showDisplayOptions()"
            class="hidden-sm btn-small"
            [hidden]="selectedTab?.key === INBOX_TYPES.ESCALATIONS"
          >
            <ion-icon name="options" class="margin-right-5"></ion-icon>
            Display
          </ion-button>
          <ion-button
            fill="clear"
            color="dark"
            (click)="
              layoutType === 'grid' ? showCsvDownloadOptions() : exportAsCsv()
            "
            ngxTippy
            [tippyProps]="{
              arrow: false,
              placement: 'bottom'
            }"
            data-tippy-content="Download as CSV"
            class="hidden-sm btn-small"
            [disabled]="isDownloadingCsv"
            [hidden]="selectedTab?.key === INBOX_TYPES.ESCALATIONS"
          >
            <ion-icon
              name="cloud-download"
              *ngIf="!isDownloadingCsv"
            ></ion-icon>
            <ion-spinner name="crescent" *ngIf="isDownloadingCsv"></ion-spinner>
          </ion-button>
        </div>
      </div>
      <div
        [hidden]="!isProcessingBulkUpdate"
        class="flexed-align-center"
        style="margin: 1px 0"
      >
        <ion-spinner name="crescent" style="margin-left: 10px"></ion-spinner>
        <ion-button
          fill="clear"
          color="dark"
          [disabled]="true"
          class="hidden-sm btn-small"
        >
          Updating {{ bulkUpdateCount }} conversations...
        </ion-button>
      </div>
      <div
        [hidden]="!selectedConversations?.length"
        class="flexed-align-center"
        style="margin: 1px 0"
      >
        <ion-button
          fill="clear"
          color="dark"
          [disabled]="true"
          class="hidden-sm btn-small"
        >
          Bulk update
          {{
            selectAllPagesForBulkUpdate
              ? conversationsDataSource.lastResponse.totalCount
              : selectedConversations?.length
          }}
          selected:
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          [disabled]="isLoading"
          (click)="bulkChangeStatus()"
          class="btn-small button-dark-border"
        >
          <span class="text-with-right-icon"> Status </span>
          <ion-icon name="chevron-down-outline" class="button-icon"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          [disabled]="isLoading || selectAllPagesForBulkUpdate"
          (click)="bulkEditTags()"
          class="btn-small button-dark-border"
        >
          <span class="text-with-right-icon"> Tags </span>
          <ion-icon name="chevron-down-outline" class="button-icon"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          [disabled]="isLoading"
          (click)="bulkChangeAssignee()"
          class="btn-small button-dark-border"
        >
          <span class="text-with-right-icon"> Assignee </span>
          <ion-icon name="chevron-down-outline" class="button-icon"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          [disabled]="isLoading"
          (click)="bulkChangeTicketType()"
          class="btn-small button-dark-border"
        >
          <span class="text-with-right-icon"> Ticket type </span>
          <ion-icon name="chevron-down-outline" class="button-icon"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          [disabled]="isLoading"
          (click)="bulkOptions()"
          class="btn-small button-dark-border"
        >
          <span class="text-with-right-icon hidden-sm"> More </span>
          <ion-icon name="ellipsis-vertical" class="button-icon"></ion-icon>
        </ion-button>
        <ng-container
          *ngIf="
            selectedConversations?.length >= limit &&
            layoutType === 'table' &&
            isOnFirstPage &&
            !isProcessingBulkUpdate
          "
        >
          <ng-container
            *ngIf="!selectAllPagesForBulkUpdate && getWhereClauses().length"
          >
            <ion-button
              fill="clear"
              color="dark"
              (click)="selectAllPagesForBulkUpdate = true"
              class="btn-small"
            >
              Select all
              {{ conversationsDataSource.lastResponse.totalCount }} in inbox?
            </ion-button>
          </ng-container>
        </ng-container>
        <ion-button
          fill="clear"
          color="dark"
          (click)="clearSelectedConversations()"
          class="btn-small"
        >
          Clear selection
        </ion-button>
      </div>
    </div>
  </div>
</ion-header>
<ion-content
  [ngClass]="{
    'kanban-content':
      layoutType === 'grid' &&
      selectedTab?.key !== INBOX_TYPES.CLOSED &&
      selectedTab?.key !== INBOX_TYPES.INTAKE &&
      selectedTab?.key !== INBOX_TYPES.ESCALATIONS
  }"
>
  <ion-grid
    *ngIf="
      layoutType === 'grid' &&
      selectedTab?.key !== INBOX_TYPES.CLOSED &&
      selectedTab?.key !== INBOX_TYPES.INTAKE &&
      selectedTab?.key !== INBOX_TYPES.ESCALATIONS
    "
    class="grid"
  >
    <ion-row style="flex-wrap: nowrap; overflow-x: auto; height: 100%">
      <ng-container *ngFor="let column of kanbanColumns">
        <ion-col
          *ngIf="isKanbanColumnVisible(column.key)"
          size="12"
          size-sm="3"
          class="kanban-col"
          (drop)="onDrop($event, column.key)"
          (dragover)="onDragOver($event, column.key)"
          (dragleave)="onDragOut($event, column.key)"
          [ngClass]="{
            'dragged-col-active': dragHighlightedCol === column.key
          }"
        >
          <div class="kanban-header">
            <div [class]="'status-label status-label-' + column.cssClass">
              <ion-icon [name]="column.icon"></ion-icon>
              {{ column.label }}
            </div>
            <ion-text
              [color]="column.countColor"
              class="kanban-count"
              *ngIf="getColumnCount(column.key) >= 0"
            >
              {{
                column.key === "closed" && getColumnCount(column.key) > 999
                  ? "999+"
                  : getColumnCount(column.key)
              }}
            </ion-text>
            <a
              class="kanban-checkbox"
              (click)="showKanbanOptions(column.key)"
              [hidden]="!getColumnCount(column.key)"
            >
              <ion-icon name="ellipsis-horizontal"></ion-icon>
            </a>
          </div>
          <app-conversation-list
            [attr.convoComponent]="column.componentAttribute"
            [sortDesc]="sortDesc"
            [sortField]="sortField"
            [searchText]="searchText"
            [whereClauses]="getWhereClauses(column.key)"
            [routerPath]="getBaseRouterLink()"
            [dragEnabled]="dragEnabled"
            [viewTag]="column.key"
            [showTags]="true"
            [rightClickEnabled]="true"
            (conversationSelected)="kanbanSelectionDidChange($event)"
            (conversationStartedDragging)="kanbanDidStartDragging($event)"
            (conversationStoppedDragging)="kanbanDidStopDragging($event)"
            (didUpdateConversationCount)="kanbanDidUpdateCount($event)"
          ></app-conversation-list>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>

  <ngx-datatable
    *ngIf="
      (layoutType === 'table' ||
        (layoutType === 'grid' && selectedTab?.key === INBOX_TYPES.CLOSED) ||
        (layoutType === 'grid' && selectedTab?.key === INBOX_TYPES.INTAKE)) &&
      selectedTab?.key !== INBOX_TYPES.ESCALATIONS
    "
    class="material datatable-row-borders datatable-fixed-header datatable-fixed-footer"
    [columnMode]="ColumnMode.force"
    [limit]="limit"
    [headerHeight]="46"
    [footerHeight]="50"
    [rowHeight]="tableRowHeight"
    [scrollbarH]="true"
    [reorderable]="true"
    [selected]="selectedConversations"
    (select)="onSelect($event)"
    [displayCheck]="false"
    selectionType="checkbox"
    [selectAllRowsOnPage]="false"
    [rowIdentity]="getRowIdentity"
    style="height: unset"
    paginated
    [dataSource]="conversationsDataSource"
    [loadingIndicator]="isLoading"
  >
    <ngx-datatable-column
      [width]="44"
      [minWidth]="44"
      [sortable]="false"
      [canAutoResize]="false"
      [draggable]="false"
      [resizeable]="false"
      [headerCheckboxable]="true"
      [checkboxable]="true"
      *ngIf="tableShowId"
    >
    </ngx-datatable-column>

    <!-- Dynamic columns based on tableColumns configuration -->
    <ng-container *ngFor="let column of getVisibleColumnsInOrder()">
      <!-- Status Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'status'"
        [name]="getColumnDisplayName(column.id)"
        [maxWidth]="getColumnWidth(column.id).maxWidth || 84"
        [minWidth]="getColumnWidth(column.id).minWidth || 84"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <a
            [routerLink]="[getBaseRouterLink(), row.id]"
            (click)="cacheConversation(row)"
            (contextmenu)="onStatusRightClick($event, row)"
            style="margin-left: -10px"
          >
            <div
              class="status-label status-label-needs-response clickable"
              *ngIf="value === CONVERSATION_STATUS.OPEN"
            >
              <ion-icon name="custom-open"></ion-icon>
              #{{ row.friendlyId }}
            </div>
            <div
              class="status-label status-label-in-progress clickable"
              *ngIf="value === CONVERSATION_STATUS.IN_PROGRESS"
            >
              <ion-icon name="custom-in-progress"></ion-icon>
              #{{ row.friendlyId }}
            </div>
            <div
              class="status-label status-label-on-hold clickable"
              *ngIf="value === CONVERSATION_STATUS.ON_HOLD"
            >
              <ion-icon name="custom-on-hold"></ion-icon>
              #{{ row.friendlyId }}
            </div>
            <div
              class="status-label status-label-closed clickable"
              *ngIf="value === CONVERSATION_STATUS.CLOSED"
            >
              <ion-icon name="custom-closed"></ion-icon>
              #{{ row.friendlyId }}
            </div>
            <div
              class="status-label status-label-intake clickable"
              *ngIf="value === CONVERSATION_STATUS.INTAKE"
            >
              <ion-icon name="custom-intake"></ion-icon>
              #{{ row.friendlyId }}
            </div>
          </a>
        </ng-template>
      </ngx-datatable-column>

      <!-- Message Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'message'"
        [name]="getColumnDisplayName(column.id)"
        prop="initialMessage"
        [minWidth]="getColumnWidth(column.id).minWidth || tableMessageWidth"
        [sortable]="false"
      >
        <ng-template
          let-row="row"
          let-value="value"
          ngx-datatable-cell-template
        >
          <a
            [routerLink]="[getBaseRouterLink(), row.id]"
            (click)="cacheConversation(row)"
            title="{{ row.summary || formatContent(row, 100) }}"
            style="font-size: 0.85rem; overflow-x: hidden"
            class="row-title row-link"
          >
            {{ formatContent(row, 100) }}
          </a>
          <div style="padding: 12px; position: sticky; right: -20px">
            <ion-button
              *ngIf="row.notes"
              [ngxTippy]="'<strong>Note</strong><br>' + row.notes"
              [tippyProps]="{
                arrow: false,
                placement: 'bottom',
                allowHTML: true
              }"
              (click)="viewNotes(row)"
              class="inbox-accessory"
              color="dark"
              fill="clear"
            >
              <ion-icon name="information-circle"></ion-icon>
            </ion-button>
            <ion-button
              *ngIf="row.priority && row.priorityEmoji && row.priorityLabel"
              class="tag-accessory clickable inbox-accessory"
              (click)="changePriority(row)"
              fill="clear"
              color="dark"
            >
              <img
                *ngIf="isURL(row.priorityEmoji | colonToEmoji)"
                [src]="row.priorityEmoji | colonToEmoji"
                ngxTippy
                [attr.data-tippy-content]="row.priorityLabel"
                alt="Emoji"
                style="width: 1em"
              />
              <span
                *ngIf="!isURL(row.priorityEmoji | colonToEmoji)"
                class="action-icon"
                ngxTippy
                [attr.data-tippy-content]="row.priorityLabel"
              >
                {{ row.priorityEmoji | colonToEmoji }}
              </span>
            </ion-button>
            <ion-button
              *ngIf="row.externalTasks?.length"
              ngxTippy
              [tippyProps]="{
                arrow: false,
                placement: 'bottom'
              }"
              [ngxTippy]="
                'View linked tasks (' + row.externalTasks?.length + ')'
              "
              (click)="viewTasks(row)"
              class="inbox-accessory"
              color="dark"
              fill="clear"
            >
              <ion-icon name="checkbox-outline"></ion-icon>
            </ion-button>
            <ng-container *ngFor="let escalation of row.escalations">
              <ion-button
                ngxTippy
                [ngxTippy]="
                  '<strong>Escalation (' +
                  ESCALATION_STATUS_LABELS[escalation.status] +
                  '):</strong> ' +
                  escalation.title
                "
                [tippyProps]="{
                  arrow: false,
                  placement: 'bottom',
                  allowHTML: true
                }"
                class="inbox-accessory"
                fill="clear"
                [color]="getEscalationStatusColor(escalation.status)"
              >
                <ion-icon
                  name="alert-circle"
                  style="font-size: 0.9rem"
                ></ion-icon>
              </ion-button>
            </ng-container>
            <ion-button
              *ngIf="
                row.summary && authService.isAiFeatureEnabled('autoSummarize')
              "
              [ngxTippy]="'<strong>✨ Summary</strong><br>' + row.summary"
              [tippyProps]="{
                arrow: false,
                placement: 'bottom',
                allowHTML: true
              }"
              (click)="viewSummary(row)"
              class="inbox-accessory"
              fill="clear"
              color="dark"
            >
              <ion-icon name="reader" style="font-size: 0.9rem"></ion-icon>
            </ion-button>
            <ion-button
              *ngIf="
                authService.isAiFeatureEnabled('customerSentiment') &&
                row.sentiment !== null &&
                (getSentimentVote(row) <= 40 || getSentimentVote(row) >= 60)
              "
              color="dark"
              fill="clear"
              class="inbox-accessory"
            >
              <span
                [tippyProps]="{
                  arrow: false,
                  placement: 'bottom'
                }"
                *ngIf="getSentimentVote(row) <= 40"
                [ngxTippy]="
                  'Sentiment: ' + getSentimentVote(row) + '% positive'
                "
                style="color: red"
              >
                😡
              </span>
              <span
                [tippyProps]="{
                  arrow: false,
                  placement: 'bottom'
                }"
                [ngxTippy]="
                  'Sentiment: ' + getSentimentVote(row) + '% positive'
                "
                *ngIf="getSentimentVote(row) >= 60"
                style="color: green"
              >
                😀
              </span>
            </ion-button>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <!-- Submitter Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'submitter'"
        [name]="getColumnDisplayName(column.id)"
        prop="submitterUser"
        [minWidth]="getColumnWidth(column.id).minWidth || 180"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <app-avatar
            size="23"
            *ngIf="value.photo"
            [style.width]="'23px'"
            [style.min-width]="'23px'"
            [style.height]="'23px'"
            [name]="value.name"
            [image]="value.photo"
          >
          </app-avatar>
          <span style="margin-left: 4px" *ngIf="value.link">{{
            value.name
          }}</span>
          <span style="margin-left: 4px" *ngIf="!value.link">
            {{ value.name }}{{ value.userType === "bot" ? " (bot)" : "" }}
          </span>
        </ng-template>
      </ngx-datatable-column>

      <!-- Customer Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'customer'"
        [name]="getColumnDisplayName(column.id)"
        prop="customer"
        [minWidth]="getColumnWidth(column.id).minWidth || 180"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <ion-button
            fill="clear"
            color="dark"
            class="btn-small"
            (click)="viewCustomer(value?.id)"
            [disabled]="!value"
            style="margin-left: -13px"
          >
            <img
              *ngIf="
                value?.slackTeams?.length === 1 && value?.slackTeams[0]?.icon
              "
              [src]="value?.slackTeams[0].icon"
              style="
                border-radius: 5px;
                width: 18px;
                height: 18px;
                margin-right: 5px;
              "
            />
            <span *ngIf="value">{{ value.name ?? PRIVATE_CHANNEL_NAME }}</span>
            <i *ngIf="!value">None</i>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>

      <!-- Assignee Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'assignee'"
        [name]="getColumnDisplayName(column.id)"
        prop="assignedToUser.name"
        [minWidth]="getColumnWidth(column.id).minWidth || 180"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <ion-chip outline class="assignee-chip" (click)="changeAssignee(row)">
            <app-avatar
              size="23"
              *ngIf="row.assignedToUser"
              [style.width]="'23px'"
              [style.min-width]="'23px'"
              [style.height]="'23px'"
              [name]="row.assignedToUser.name"
              [image]="row.assignedToUser.photo"
            >
            </app-avatar>
            <ion-icon
              name="ellipse-outline"
              style="margin: 0; opacity: 0.5; font-size: 1.7rem"
              *ngIf="!row.assignedToUser"
            ></ion-icon>
            <span style="margin-left: 4px">
              {{
                row.assignedToUser ? row?.assignedToUser?.name : "Unassigned"
              }}
            </span>
          </ion-chip>
        </ng-template>
      </ngx-datatable-column>

      <!-- Ticket Type Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'ticketType'"
        [name]="getColumnDisplayName(column.id)"
        prop="ticketType"
        [minWidth]="getColumnWidth(column.id).minWidth || 180"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <span *ngIf="value">{{ value.name }}</span>
        </ng-template>
      </ngx-datatable-column>

      <!-- Account Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'account' && authService.tenant.accountsEnabled"
        [name]="getColumnDisplayName(column.id)"
        prop="account"
        [minWidth]="getColumnWidth(column.id).minWidth || 180"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <span *ngIf="value">{{ value.name }}</span>
        </ng-template>
      </ngx-datatable-column>

      <!-- Submitted Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'submitted'"
        [name]="getColumnDisplayName(column.id)"
        prop="createdAt"
        [minWidth]="getColumnWidth(column.id).minWidth || 170"
        [maxWidth]="getColumnWidth(column.id).maxWidth || 170"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <span title="{{ value | customDate: 'dateTime' }}">{{
            displayDate(value)
          }}</span>
        </ng-template>
      </ngx-datatable-column>

      <!-- Tags Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'tags'"
        [name]="getColumnDisplayName(column.id)"
        [minWidth]="getColumnWidth(column.id).minWidth || 250"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-chip
            mode="ios"
            color="primary"
            class="btn-small tag-chip"
            *ngFor="let tag of row.tags"
          >
            <ion-label [title]="getTagsForRow(row)">
              {{ tag.name }}
            </ion-label>
          </ion-chip>
        </ng-template>
      </ngx-datatable-column>

      <!-- Customer Tags Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'customerTags'"
        [name]="getColumnDisplayName(column.id)"
        [minWidth]="getColumnWidth(column.id).minWidth || 250"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-chip
            mode="ios"
            color="primary"
            class="btn-small tag-chip"
            *ngFor="let tag of row.customer?.tags"
          >
            <ion-label [title]="getTagsForRow(row)">
              {{ tag.name }}
            </ion-label>
          </ion-chip>
        </ng-template>
      </ngx-datatable-column>

      <!-- Response Time Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'responseTime'"
        [name]="getColumnDisplayName(column.id)"
        prop="responseTimeWorking"
        [minWidth]="getColumnWidth(column.id).minWidth || 170"
        [maxWidth]="getColumnWidth(column.id).maxWidth || 170"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          {{ displayDuration(value) }}
        </ng-template>
      </ngx-datatable-column>

      <!-- Resolution Time Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'resolutionTime'"
        [name]="getColumnDisplayName(column.id)"
        prop="resolutionTimeWorking"
        [minWidth]="getColumnWidth(column.id).minWidth || 170"
        [maxWidth]="getColumnWidth(column.id).maxWidth || 170"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          {{ displayDuration(value) }}
        </ng-template>
      </ngx-datatable-column>

      <!-- Last Activity Time Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'lastActivityAt'"
        [name]="getColumnDisplayName(column.id)"
        prop="lastActivityAt"
        [minWidth]="getColumnWidth(column.id).minWidth || 170"
        [maxWidth]="getColumnWidth(column.id).maxWidth || 170"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <span title="{{ value | customDate: 'dateTime' }}">{{
            displayDate(value)
          }}</span>
        </ng-template>
      </ngx-datatable-column>

      <!-- Project Column -->
      <ngx-datatable-column
        *ngIf="column.id === 'project'"
        [name]="getColumnDisplayName(column.id)"
        prop="project?.name"
        [minWidth]="getColumnWidth(column.id).minWidth || 180"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-icon
            name="lock-closed"
            *ngIf="row.project?.visibility === PROJECT_VISIBILITY.RESTRICTED"
          ></ion-icon>
          <span
            >{{ row.project?.name }}
            <i *ngIf="!row.project?.name">None</i>
          </span>
        </ng-template>
      </ngx-datatable-column>
    </ng-container>
  </ngx-datatable>

  <!-- Escalation Table -->
  <ngx-datatable
    *ngIf="selectedTab?.key === INBOX_TYPES.ESCALATIONS"
    class="material datatable-row-borders datatable-row-top-aligned datatable-fixed-header datatable-fixed-footer"
    [columnMode]="ColumnMode.force"
    [limit]="limit"
    [headerHeight]="46"
    [footerHeight]="50"
    [rowHeight]="'auto'"
    [scrollbarH]="true"
    [reorderable]="false"
    style="height: unset"
    paginated
    [dataSource]="escalationsDataSource"
    [loadingIndicator]="isLoading"
  >
    <!-- Status Column -->
    <ngx-datatable-column
      name="Status"
      [maxWidth]="getEscalationColumnWidth('status').maxWidth || 84"
      [minWidth]="getEscalationColumnWidth('status').minWidth || 84"
      [sortable]="false"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-badge
          [color]="getEscalationStatusColor(row.status)"
          class="status-badge clickable"
          (click)="changeEscalationStatus(row, $event)"
        >
          <ion-icon [name]="getEscalationStatusIcon(row.status)"></ion-icon>
          {{ ESCALATION_STATUS_LABELS[row.status] }}
        </ion-badge>
      </ng-template>
    </ngx-datatable-column>

    <!-- Title Column -->
    <ngx-datatable-column
      name="Escalation"
      prop="title"
      [sortable]="false"
      [minWidth]="getEscalationColumnWidth('title').minWidth || 460"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div class="row-link clickable" (click)="openEscalation(row)">
          <div class="flexed-align-center">
            <span class="row-title" style="font-size: 0.9rem">
              {{ row.title }}
            </span>
            <span
              *ngIf="row.priority"
              class="tag-accessory inbox-accessory flexed-align-center"
              fill="clear"
              color="dark"
              style="margin-left: 7px; height: 23px"
              ngxTippy
              [attr.data-tippy-content]="displayPriority(row.priority)"
            >
              <ng-container
                *ngIf="
                  displayPriorityEmoji(row.priority)
                    | colonToEmoji as emojiString
                "
              >
                <img
                  *ngIf="isURL(emojiString)"
                  [src]="emojiString"
                  alt="Priority Emoji"
                  style="width: 1em; height: 1em; vertical-align: -0.125em"
                />
                <span *ngIf="!isURL(emojiString)" class="action-icon">
                  {{ emojiString }}
                </span>
              </ng-container>
              <ion-icon
                *ngIf="
                  !displayPriorityEmoji(row.priority) &&
                  getIconForPriority(row.priority)
                "
                [name]="getIconForPriority(row.priority)"
              ></ion-icon>
            </span>
          </div>
          <ion-text
            color="medium"
            style="font-size: 0.8rem"
            *ngIf="row.conversation"
          >
            <span
              class="status-label-needs-response"
              *ngIf="row.conversation.status === CONVERSATION_STATUS.OPEN"
              ngxTippy
              [ngxTippy]="row.conversation.subStatus?.name || 'No substatus'"
              [tippyProps]="{
                arrow: false,
                placement: 'bottom'
              }"
            >
              <ion-icon name="custom-open"></ion-icon>
              #{{ row.conversation.friendlyId }}
            </span>
            <span
              class="status-label-in-progress"
              *ngIf="
                row.conversation.status === CONVERSATION_STATUS.IN_PROGRESS
              "
              ngxTippy
              [ngxTippy]="row.conversation.subStatus?.name || 'No substatus'"
              [tippyProps]="{
                arrow: false,
                placement: 'bottom'
              }"
            >
              <ion-icon name="custom-in-progress"></ion-icon>
              #{{ row.conversation.friendlyId }}
            </span>
            <span
              class="status-label-on-hold"
              *ngIf="row.conversation.status === CONVERSATION_STATUS.ON_HOLD"
              ngxTippy
              [ngxTippy]="row.conversation.subStatus?.name || 'No substatus'"
              [tippyProps]="{
                arrow: false,
                placement: 'bottom'
              }"
            >
              <ion-icon name="custom-on-hold"></ion-icon>
              #{{ row.conversation.friendlyId }}
            </span>
            <span
              class="status-label-closed"
              *ngIf="row.conversation.status === CONVERSATION_STATUS.CLOSED"
              ngxTippy
              [ngxTippy]="row.conversation.subStatus?.name || 'No substatus'"
              [tippyProps]="{
                arrow: false,
                placement: 'bottom'
              }"
            >
              <ion-icon name="custom-closed"></ion-icon>
              #{{ row.conversation.friendlyId }}
            </span>
            <span
              class="status-label-intake"
              *ngIf="row.conversation.status === CONVERSATION_STATUS.INTAKE"
              ngxTippy
              [ngxTippy]="row.conversation.subStatus?.name || 'No substatus'"
              [tippyProps]="{
                arrow: false,
                placement: 'bottom'
              }"
            >
              <ion-icon name="custom-intake"></ion-icon>
              #{{ row.conversation.friendlyId }}
            </span>
            {{ row.conversation?.title }}
          </ion-text>
        </div>
      </ng-template>
    </ngx-datatable-column>

    <!-- Escalation Type Column -->
    <ngx-datatable-column
      name="Escalation Type"
      prop="escalationType.name"
      [sortable]="false"
      [minWidth]="getEscalationColumnWidth('escalationType').minWidth || 180"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span>{{ row.escalationType?.name || "N/A" }}</span>
      </ng-template>
    </ngx-datatable-column>

    <!-- Ticket Type Column -->
    <ngx-datatable-column
      name="Ticket Type"
      prop="conversation.ticketType.name"
      [sortable]="false"
      [minWidth]="getEscalationColumnWidth('ticketType').minWidth || 180"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span>{{ row.conversation?.ticketType?.name || "N/A" }}</span>
      </ng-template>
    </ngx-datatable-column>

    <!-- Assignee Column -->
    <ngx-datatable-column
      name="Assignee"
      [sortable]="false"
      [minWidth]="getEscalationColumnWidth('assignee').minWidth || 180"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div class="flexed-align-center">
          <app-avatar
            size="23"
            *ngIf="row.assignedToUser"
            [style.width]="'23px'"
            [style.height]="'23px'"
            [style.min-width]="'23px'"
            [name]="row.assignedToUser.name"
            [image]="row.assignedToUser.photo"
          >
          </app-avatar>
          <ion-icon
            name="ellipse-outline"
            style="margin: 0; opacity: 0.5; font-size: 1.7rem"
            *ngIf="!row.assignedToUser"
          ></ion-icon>
          <span style="margin-left: 4px">
            {{ row.assignedToUser ? row.assignedToUser.name : "Unassigned" }}
          </span>
        </div>
      </ng-template>
    </ngx-datatable-column>

    <!-- Created Column -->
    <ngx-datatable-column
      name="Created"
      prop="createdAt"
      [minWidth]="getEscalationColumnWidth('createdAt').minWidth || 170"
      [maxWidth]="getEscalationColumnWidth('createdAt').maxWidth || 170"
      [sortable]="true"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span title="{{ row.createdAt | date: 'MMM d yyyy h:mm a' }}">{{
          displayEscalationDate(row.createdAt)
        }}</span>
      </ng-template>
    </ngx-datatable-column>

    <!-- Updated Column -->
    <ngx-datatable-column
      name="Updated"
      prop="updatedAt"
      [minWidth]="getEscalationColumnWidth('updatedAt').minWidth || 170"
      [maxWidth]="getEscalationColumnWidth('updatedAt').maxWidth || 170"
      [sortable]="true"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span title="{{ row.updatedAt | date: 'MMM d yyyy h:mm a' }}">{{
          displayEscalationDate(row.updatedAt)
        }}</span>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>

  <div
    *ngIf="
      layoutType === 'sidebar' && selectedTab?.key !== INBOX_TYPES.ESCALATIONS
    "
    class="sidebar-container"
  >
    <div class="sidebar-header">
      <div class="flex-space-between flexed-align-center">
        <ion-searchbar
          mode="ios"
          class="search-bar hidden-sm"
          placeholder="Search conversations..."
          showCancelButton="never"
          [(ngModel)]="searchText"
          (ionChange)="onSearch()"
        ></ion-searchbar>
        <ion-button
          class="sidebar-options-button"
          fill="clear"
          [color]="showingSidebarOptions ? 'primary' : 'dark'"
          (click)="showingSidebarOptions = !showingSidebarOptions"
        >
          <ion-icon
            [name]="showingSidebarOptions ? 'filter' : 'filter-outline'"
            class="button-icon"
          ></ion-icon>
        </ion-button>
        <ion-button
          class="sidebar-options-button"
          fill="clear"
          color="dark"
          (click)="showDisplayOptions()"
        >
          <ion-icon name="options" class="button-icon"></ion-icon>
        </ion-button>
      </div>
      <div
        [hidden]="
          selectedTab?.key === INBOX_TYPES.CLOSED ||
          selectedTab?.key === INBOX_TYPES.INTAKE ||
          savedFilterId
        "
        style="margin: 8px; text-align: center"
        class="pill-tab-container"
      >
        <div
          *ngFor="let statusOption of statusFilterOptions; let i = index"
          [class]="
            'round-pill-tab ' +
            (i === 0 ? 'round-pill-tab-left ' : '') +
            (i === statusFilterOptions.length - 1
              ? 'round-pill-tab-right '
              : '') +
            (statusIndex === i ? 'round-pill-tab-active' : '')
          "
          (click)="selectStatus(i)"
          style="font-size: 0.7rem; flex-grow: 1"
        >
          {{ statusOption.label }}
        </div>
      </div>
      <div
        class="sidebar-options-animated"
        [ngClass]="{ expanded: showingSidebarOptions }"
        [hidden]="selectedTab?.key === INBOX_TYPES.ESCALATIONS"
      >
        <app-filter-button
          [options]="filterOptions"
          [selected]="filters"
          (didChange)="filtersDidChange($event)"
          savedFilterView="inbox"
          [saveHandler]="onSaveFilter"
          [allowNotEqualsOperator]="true"
          [projectId]="authService.selectedProject?.id ?? undefined"
        ></app-filter-button>
      </div>
    </div>
    <div class="sidebar-content">
      <app-conversation-list
        #sidebarConvoList
        routerPath="view"
        routerDirection="root"
        [isSidebarMode]="true"
        [disableAssignment]="true"
        [whereClauses]="getWhereClauses()"
        [sortDesc]="sortDesc"
        [sortField]="sortField"
        [searchText]="searchText"
        [disableSelection]="true"
        [dragEnabled]="false"
        [showEmptyState]="true"
        [rightClickEnabled]="true"
        (conversationSelected)="sidebarSelectionDidChange($event)"
        (didUpdateConversationCount)="kanbanDidUpdateCount($event)"
      ></app-conversation-list>
    </div>
    <div
      class="sidebar-footer flex-space-between"
      [hidden]="!sidebarConvoCount"
    >
      <ion-buttons>
        <ion-button
          [disabled]="true"
          *ngIf="
            selectedSidebarConversationIndex >= 0 &&
            (sidebarConvoCount || sidebarConvoCount === 0)
          "
        >
          {{ selectedSidebarConversationIndex + 1 }} of {{ sidebarConvoCount }}
        </ion-button>
      </ion-buttons>
      <ion-buttons>
        <ion-button
          (click)="goToPreviousConversation()"
          [disabled]="selectedSidebarConversationIndex <= 0"
        >
          <ion-icon name="chevron-up-outline"> </ion-icon>
        </ion-button>
        <ion-button
          (click)="goToNextConversation()"
          [disabled]="
            selectedSidebarConversationIndex === sidebarConvoCount - 1
          "
        >
          <ion-icon name="chevron-down-outline"> </ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
</ion-content>
<ion-router-outlet
  *ngIf="layoutType === 'sidebar'"
  style="left: 302px; background: var(--left-nav-background)"
></ion-router-outlet>
